/* ==========================================================================
   Animaciones de entrada para las secciones existentes del tema
   (cabeceras, origen, columnas, cafetera, bundles, historia, stats, FAQ…).

   No modifica el HTML de las secciones: marca sus elementos con data-er y
   los revela al entrar en pantalla, en cascada. Usa las propiedades
   independientes translate/scale/rotate para no pisar los transform que
   algunas secciones ya usan para colocar elementos.

   Para animar una sección nueva basta con añadir sus selectores a CONFIG.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__ebocaReveal) return;
  window.__ebocaReveal = true;

  // a: tipo de animación (up, rise, zoom, grow, pop, leaf, fade)
  // each: cada elemento cuenta como un paso de la cascada
  var CONFIG = [
    // Cabeceras «título + badge + logo»
    { s: '.lh__badge', a: 'pop' },
    { s: '.lh__logo', a: 'pop' },
    { s: '.lh__heading', a: 'up' },
    { s: '.lh__subheading', a: 'up' },
    { s: '.lh__trust-item', a: 'up', each: true },

    // Origen: 3 imágenes sobre fondo amarillo
    { s: '.landing-origin__platform', a: 'grow' },
    { s: '.landing-origin__item-image-wrap', a: 'rise', each: true, tilt: true },
    { s: '.landing-origin__item-content', a: 'up', each: true },

    // Columnas de texto / imagen
    { s: '.landing-columns__decorative', a: 'leaf' },
    { s: '.landing-columns__col', a: 'up', each: true },

    // Cafetera
    { s: '.landing-machine__decoration', a: 'leaf' },
    { s: '.landing-machine__media', a: 'zoom' },
    { s: '.landing-machine__label', a: 'up' },
    { s: '.landing-machine__heading', a: 'up' },
    { s: '.landing-machine__text', a: 'up' },
    { s: '.landing-machine__feature', a: 'up', each: true },

    // Cafetera Meira (sección nueva)
    { s: '.lmeira__label', a: 'up' },
    { s: '.lmeira__heading', a: 'up' },
    { s: '.lmeira__text', a: 'up' },
    { s: '.lmeira__more .lfp-more__item', a: 'up', each: true },
    { s: '.lmeira__image', a: 'zoom' },
    { s: '.lmeira__price', a: 'pop' },
    { s: '.lmeira__btn', a: 'up', each: true },

    // Bundles
    { s: '.landing-bundles__intro-heading', a: 'up' },
    { s: '.landing-bundles__intro-subheading', a: 'up' },
    { s: '.landing-bundles__card', a: 'rise', each: true },

    // Bloques de contenido
    { s: '.landing-content__block', a: 'up', each: true },

    // Historia de origen
    { s: '.landing-origin-story__badge', a: 'pop' },
    { s: '.landing-origin-story__heading', a: 'up' },
    { s: '.landing-origin-story__text', a: 'up' },
    { s: '.landing-origin-story__image', a: 'zoom' },
    { s: '.landing-origin-story__map', a: 'zoom' },
    { s: '.landing-origin-story__details-left', a: 'up' },
    { s: '.landing-origin-story__details-right', a: 'up' },

    // Imagen con texto superpuesto
    { s: '.home-intro__content', a: 'up' },

    // Cifras (con contador)
    { s: '.landing-stats__item', a: 'up', each: true, count: '.landing-stats__value' },

    // Opiniones
    { s: '.landing-testimonials__header', a: 'up' },
    { s: '.landing-testimonials__slider-wrap', a: 'up' },

    // FAQ
    { s: '.landing-faq__decor', a: 'leaf' },
    { s: '.landing-faq__title', a: 'up' },
    { s: '.landing-faq__item', a: 'up', each: true }
  ];

  var STEP_MS = 90;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Contador: anima el número de un texto como "+12.000" o "4,8/5" */
  function countUp(el) {
    var original = el.textContent;
    var m = /^(\D*)(\d[\d.,]*)(.*)$/.exec(original.trim());
    if (!m) return;
    var raw = m[2];
    var target, decimals = 0, sepDecimal = '', thousands = '';
    var dec = /[.,](\d{1,2})$/.exec(raw); // "4,8" / "4.8" → decimales
    if (dec) {
      decimals = dec[1].length;
      sepDecimal = raw.charAt(raw.length - decimals - 1);
      target = parseFloat(raw.slice(0, -decimals - 1).replace(/[.,]/g, '') + '.' + dec[1]);
    } else {
      var sep = /[.,]/.exec(raw); // "12.000" → separador de miles
      thousands = sep ? sep[0] : '';
      target = parseInt(raw.replace(/[.,]/g, ''), 10);
    }
    if (!isFinite(target) || target === 0) return;
    var start = null;
    var duration = 1400;

    function format(v) {
      var s = decimals ? v.toFixed(decimals).replace('.', sepDecimal) : String(Math.round(v));
      if (thousands) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return m[1] + s + m[3];
    }

    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = format(target * eased);
      if (t < 1) requestAnimationFrame(frame);
      else el.textContent = original;
    }
    requestAnimationFrame(frame);
  }

  function prepare(section) {
    var step = 0;
    var marked = [];
    var counters = [];

    CONFIG.forEach(function (rule) {
      var els = section.querySelectorAll(rule.s);
      if (!els.length) return;
      Array.prototype.forEach.call(els, function (el, i) {
        if (el.hasAttribute('data-er')) return;
        el.setAttribute('data-er', rule.a);
        el.style.setProperty('--er-d', step);
        if (rule.tilt) el.style.setProperty('--er-tilt', (i % 3 === 0 ? -4 : i % 3 === 2 ? 4 : 0) + 'deg');
        if (rule.count) {
          var c = el.querySelector(rule.count);
          if (c) counters.push(c);
        }
        marked.push(el);
        if (rule.each) step++;
      });
      if (!rule.each) step++;
    });

    if (!marked.length) return;

    section.classList.add('er-pending');

    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      section.classList.add('er-in');
      counters.forEach(countUp);
      // Al terminar se retiran las marcas: el elemento recupera sus propias transiciones (hover, etc.)
      setTimeout(function () {
        marked.forEach(function (el) { el.removeAttribute('data-er'); el.style.removeProperty('--er-d'); el.style.removeProperty('--er-tilt'); });
        section.classList.remove('er-pending', 'er-in');
      }, step * STEP_MS + 1600);
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    io.observe(section);
  }

  function init(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return; // en el editor, todo visible
    var sections = (scope && scope.classList && scope.classList.contains('shopify-section'))
      ? [scope]
      : Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
    sections.forEach(function (section) {
      // Las secciones ya visibles al cargar no se ocultan (evita parpadeos)
      if (section.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      prepare(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
